import { Button, Space } from "antd";

const EstampSubTabs = ({ activeSubKey, onChange }) => {
  const buttons = [
    { key: "earn", label: "Earn" },
    { key: "transfer", label: "Transfer" },
    { key: "redeem", label: "Redeem" },
  ];

  return (
    <Space>
      {buttons.map((button) => (
        <Button
          key={button.key}
          type={activeSubKey === button.key ? "primary" : "default"}
          shape="round"
          onClick={() => onChange(button.key)}
        >
          {button.label}
        </Button>
      ))}
    </Space>
  );
};

export default EstampSubTabs;
